import React, { useEffect } from "react";
import { Route } from "react-router-dom";
import { UserDeleteDialog } from "./user-delete-dialog/UserDeleteDialog";
import { UsersFetchDialog } from "./users-fetch-dialog/UsersFetchDialog";
import { UsersLoadingDialog } from "./users-loading-dialog/UsersLoadingDialog";
import { UsersUpdateStateDialog } from "./users-update-status-dialog/UsersUpdateStateDialog";
import UsersCard from "./UsersCard";
import { UsersUIProvider } from "./UsersUIContext";

const UsersPage = ({ history }) => {
  const UsersUIEvents = {
    newUserButtonClick: () => {
      history.push('/users/new');
    },
    openEditUserDialog: (id) => {
      history.push(`/users/${id}/edit`);
    },
    openDeleteUserDialog: (id) => {
      history.push(`/users/${id}/delete`);
    },
    openFetchUsersDialog: () => {
      history.push(`/users/fetch`);
    },
    openUpdateUsersStatusDialog: () => {
      history.push('/users/updateStatus');
    },
  };

  useEffect(() => {
    console.log('UserPage refresh...');
  }, []);

  return (
    <UsersUIProvider UsersUIEvents={UsersUIEvents}>
      <UsersLoadingDialog />
      {/* <Route path="/users/new">
        {({ history, match }) => (
          <UserEditDialog
            show={match != null}
            onHide={() => {
              history.push("/users");
            }}
          />
        )}
      </Route>
      <Route path="/users/:id/edit">
        {({ history, match }) => (
          <UserEditDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push("/users");
            }}
          />
        )}
      </Route> */}
      <Route path='/users/:id/delete'>
        {({ history, match }) => (
          <UserDeleteDialog
            show={match != null}
            id={match && match.params.id}
            onHide={() => {
              history.push('/users');
            }}
          />
        )}
      </Route>
      <Route path='/users/fetch'>
        {({ history, match }) => (
          <UsersFetchDialog
            show={match != null}
            onHide={() => {
              history.push('/users');
            }}
          />
        )}
      </Route>
      <Route path='/users/updateStatus'>
        {({ history, match }) => (
          <UsersUpdateStateDialog
            show={match != null}
            onHide={() => {
              history.push('/users');
            }}
          />
        )}
      </Route>
      <UsersCard />
    </UsersUIProvider>
  );
};

export default UsersPage;
